<template>
  <b-card>
    <div class="d-flex justify-content-between align-items-center mb-1">
      <div>
        <h4 class="mb-25">Organisation units</h4>
        <small class="text-muted">
          Head Office, nations, regions, areas, districts and assemblies as one tree, with departments under Head Office.
          Built from the existing location records; edit them in their own screens.
        </small>
      </div>
      <div>
        <b-form-checkbox v-model="includeInactive" inline @change="load(false)">Show inactive</b-form-checkbox>
        <b-button size="sm" variant="outline-secondary" class="mr-50" @click="expand = !expand">
          {{ expand ? "Collapse" : "Expand all" }}
        </b-button>
        <b-button size="sm" variant="outline-primary" @click="load(true)">Refresh</b-button>
      </div>
    </div>

    <b-overlay :show="loading">
      <b-alert v-if="error" show variant="warning" class="p-1">{{ error }}</b-alert>
      <ul v-else-if="tree" class="list-unstyled mb-0">
        <org-unit-node :node="tree" :expand="expand" />
      </ul>
      <p v-if="tree" class="text-muted small mt-1 mb-0">{{ total }} units.</p>
    </b-overlay>
  </b-card>
</template>

<script>
import { get } from "lodash";
import { BAlert, BButton, BCard, BFormCheckbox, BOverlay } from "bootstrap-vue";
import OrgUnitNode from "@core/components/org-units/OrgUnitNode.vue";

export default {
  components: { BAlert, BButton, BCard, BFormCheckbox, BOverlay, OrgUnitNode },
  data() {
    return { loading: false, tree: null, total: 0, error: "", includeInactive: false, expand: false };
  },
  created() {
    this.load(false);
  },
  methods: {
    async load(refresh) {
      this.loading = true;
      this.error = "";
      try {
        const { data } = await this.useJwt().mainService.orgUnits.tree({
          include_inactive: this.includeInactive,
          refresh,
        });
        this.tree = get(data, "data.tree");
        this.total = get(data, "data.total", 0);
      } catch (error) {
        this.error = get(error, "response.data.message") || "Could not load the organisation tree.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
